var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-list-wrapper  __pointer" }, [
    _c(
      "span",
      {
        staticClass: "list-title",
        class: {
          down: !_vm.showLang,
          up: _vm.showLang
        },
        on: { click: _vm.toggleLangList }
      },
      [_vm._v(_vm._s(_vm.$t("lang")))]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLang,
            expression: "showLang"
          }
        ],
        staticClass: "list"
      },
      _vm._l(_vm.messages, function(key, index) {
        return _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: key.lang !== _vm.$t("lang"),
                expression: "key.lang !== $t('lang')"
              }
            ],
            key: index,
            on: {
              click: function($event) {
                return _vm.changeLocale(index)
              }
            }
          },
          [_vm._v(_vm._s(key.lang))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }